const keyMirror = require("keymirror");

module.exports = keyMirror({
  CALL_API: null,
  ADMIN_LOGIN_FAILURE: null,
  ADMIN_LOGIN_REQUEST: null,
  ADMIN_LOGIN_SUCCESS: null,

  ADMIN_LOGOUT_FAILURE: null,
  ADMIN_LOGOUT_REQUEST: null,
  ADMIN_LOGOUT_SUCCESS: null,

  //dashboard action
  GET_DASHBOARD_DATA_REQUEST: null,
  GET_DASHBOARD_DATA_SUCCESS: null,
  GET_DASHBOARD_DATA_FAILURE: null,

  GET_TRANSACTION_GRAPH_REQUEST: null,
  GET_TRANSACTION_GRAPH_SUCCESS: null,
  GET_TRANSACTION_GRAPH_FAILURE: null,

  GET_POST_GRAPH_REQUEST: null,
  GET_POST_GRAPH_SUCCESS: null,
  GET_POST_GRAPH_FAILURE: null,

  GET_UPLOAD_GRAPH_REQUEST: null,
  GET_UPLOAD_GRAPH_SUCCESS: null,
  GET_UPLOAD_GRAPH_FAILURE: null,

  //report action
  GET_REPORT_DATA_REQUEST: null,
  GET_REPORT_DATA_SUCCESS: null,
  GET_REPORT_DATA_FAILURE: null,

  GET_ACTIVITY_USERS_REQUEST: null,
  GET_ACTIVITY_USERS_SUCCESS: null,
  GET_ACTIVITY_USERS_FAILURE: null,

  GET_REVENUE_GRAPH_REQUEST: null,
  GET_REVENUE_GRAPH_SUCCESS: null,
  GET_REVENUE_GRAPH_FAILURE: null,

  GET_NUMERIC_REPORT_REQUEST: null,
  GET_NUMERIC_REPORT_SUCCESS: null,
  GET_NUMERIC_REPORT_FAILURE: null,

  //customers action
  CUSTOMER_CREATE_REQUEST: null,
  CUSTOMER_CREATE_SUCCESS: null,
  CUSTOMER_CREATE_FAILURE: null,

  GET_CUSTOMERS_REQUEST: null,
  GET_CUSTOMERS_SUCCESS: null,
  GET_CUSTOMERS_FAILURE: null,

  GET_CUSTOMER_DETAIL_REQUEST: null,
  GET_CUSTOMER_DETAIL_SUCCESS: null,
  GET_CUSTOMER_DETAIL_FAILURE: null,

  CUSTOMER_UPDATE_REQUEST: null,
  CUSTOMER_UPDATE_SUCCESS: null,
  CUSTOMER_UPDATE_FAILURE: null,

  CUSTOMER_DELETE_REQUEST: null,
  CUSTOMER_DELETE_SUCCESS: null,
  CUSTOMER_DELETE_FAILURE: null,

  CUSTOMER_DISCONNECT_REQUEST: null,
  CUSTOMER_DISCONNECT_SUCCESS: null,
  CUSTOMER_DISCONNECT_FAILURE: null,

  CUSTOMER_RESET_PASSWORD_REQUEST: null,
  CUSTOMER_RESET_PASSWORD_SUCCESS: null,
  CUSTOMER_RESET_PASSWORD_FAILURE: null,

  //posts action
  GET_POST_ITEMS_REQUEST: null,
  GET_POST_ITEMS_SUCCESS: null,
  GET_POST_ITEMS_FAILURE: null,

  GET_POST_ITEM_REQUEST: null,
  GET_POST_ITEM_SUCCESS: null,
  GET_POST_ITEM_FAILURE: null,

  GET_POSTS_ITEM_BY_TRIP_REQUEST: null,
  GET_POSTS_ITEM_BY_TRIP_SUCCESS: null,
  GET_POSTS_ITEM_BY_TRIP_FAILURE: null,

  GET_POST_ITEM_DETAIL_REQUEST: null,
  GET_POST_ITEM_DETAIL_SUCCESS: null,
  GET_POST_ITEM_DETAIL_FAILURE: null,

  GET_POSTS_TOP_RATED_REQUEST: null,
  GET_POSTS_TOP_RATED_SUCCESS: null,
  GET_POSTS_TOP_RATED_FAILURE: null,

  GET_POSTS_RECENT_REQUEST: null,
  GET_POSTS_RECENT_SUCCESS: null,
  GET_POSTS_RECENT_FAILURE: null,

  GET_POSTS_PENDING_REQUEST: null,
  GET_POSTS_PENDING_SUCCESS: null,
  GET_POSTS_PENDING_FAILURE: null,

  POST_UPDATE_REQUEST: null,
  POST_UPDATE_SUCCESS: null,
  POST_UPDATE_FAILURE: null,

  POST_DELETE_REQUEST: null,
  POST_DELETE_SUCCESS: null,
  POST_DELETE_FAILURE: null,

  //trip plan action
  GET_TRIP_PLANS_REQUEST: null,
  GET_TRIP_PLANS_SUCCESS: null,
  GET_TRIP_PLANS_FAILURE: null,

  GET_TRIP_PLAN_DETAIL_REQUEST: null,
  GET_TRIP_PLAN_DETAIL_SUCCESS: null,
  GET_TRIP_PLAN_DETAIL_FAILURE: null,

  TRIP_PLAN_UPDATE_REQUEST: null,
  TRIP_PLAN_UPDATE_SUCCESS: null,
  TRIP_PLAN_UPDATE_FAILURE: null,

  TRIP_PLAN_DELETE_REQUEST: null,
  TRIP_PLAN_DELETE_SUCCESS: null,
  TRIP_PLAN_DELETE_FAILURE: null,

  //transaction action
  GET_TRANSACTIONS_REQUEST: null,
  GET_TRANSACTIONS_SUCCESS: null,
  GET_TRANSACTIONS_FAILURE: null,

  GET_TRANSACTION_DETAIL_REQUEST: null,
  GET_TRANSACTION_DETAIL_SUCCESS: null,
  GET_TRANSACTION_DETAIL_FAILURE: null,

  TRANSACTION_UPDATE_REQUEST: null,
  TRANSACTION_UPDATE_SUCCESS: null,
  TRANSACTION_UPDATE_FAILURE: null,

  TRANSACTION_DELETE_REQUEST: null,
  TRANSACTION_DELETE_SUCCESS: null,
  TRANSACTION_DELETE_FAILURE: null,

  GET_ADMIN_SETTING_REQUEST: null,
  GET_ADMIN_SETTING_SUCCESS: null,
  GET_ADMIN_SETTING_FAILURE: null,

  GET_ADMINS_REQUEST: null,
  GET_ADMINS_SUCCESS: null,
  GET_ADMINS_FAILURE: null,

  SET_ADMIN_INFO_REQUEST: null,
  SET_ADMIN_INFO_SUCCESS: null,
  SET_ADMIN_INFO_FAILURE: null,

  ADMIN_RESET_PASSWORD_REQUEST: null,
  ADMIN_RESET_PASSWORD_SUCCESS: null,
  ADMIN_RESET_PASSWORD_FAILURE: null,
});



// WEBPACK FOOTER //
// ./common/constants/actions.js